import { makeActionCreator } from '../../config/store/utils'
import { getSmallerCompaniesSectors } from '../../services/smallerCompanies'
import { EMT_COLORS, SECTORS_COLORS, MONTHS_DICTIONARY } from '../../config/settings/constants'

export const GET_SMALLER_COMPANIES_BY_SECTOR = 'GET_SMALLER_COMPANIES_BY_SECTOR'
export const GET_SMALLER_COMPANIES_BY_SECTOR_ERROR = 'GET_SMALLER_COMPANIES_BY_SECTOR_ERROR'
export const GET_SMALLER_COMPANIES_BY_SECTOR_SUCCESS = 'GET_SMALLER_COMPANIES_BY_SECTOR_SUCCESS'

export const onGetSmallerCompaniesBySector = makeActionCreator(GET_SMALLER_COMPANIES_BY_SECTOR)
export const onGetSmallerCompaniesBySectorError = makeActionCreator(GET_SMALLER_COMPANIES_BY_SECTOR_ERROR, 'payload')
export const onGetSmallerCompaniesBySectorSuccess = makeActionCreator(
  GET_SMALLER_COMPANIES_BY_SECTOR_SUCCESS,
  'payload'
)
const getAccumulatedMonthlyData = enhancedData => {
  const accumulatedData = []

  let accMicroCLP = 0
  let accMicroUSD = 0
  let accSmallCLP = 0
  let accSmallUSD = 0
  let accMediumCLP = 0
  let accMediumUSD = 0
  let accTotalEMTCLP = 0
  let accTotalEMTUSD = 0
  let accMicroOrders = 0
  let accSmallOrders = 0
  let accMediumOrders = 0
  let accTotalOrders = 0
  let accQuantityOffersMicro = 0
  let accQuantityOffersSmall = 0
  let accQuantityOffersMedium = 0
  let accTotalOffers = 0

  const sortedData = [...enhancedData].sort((a, b) => a.month - b.month)

  for (const d of sortedData) {
    accMicroCLP += d.microCLP
    accMicroUSD += d.microUSD
    accSmallCLP += d.smallCLP
    accSmallUSD += d.smallUSD
    accMediumCLP += d.mediumCLP
    accMediumUSD += d.mediumUSD
    accTotalEMTCLP += d.totalEMT_CLP
    accTotalEMTUSD += d.totalEMT_USD
    accMicroOrders += d.microOrders
    accSmallOrders += d.smallOrders
    accMediumOrders += d.mediumOrders
    accTotalOrders += d.totalOrders
    accQuantityOffersMicro += d.quantityOffersMicro
    accQuantityOffersSmall += d.quantityOffersSmall
    accQuantityOffersMedium += d.quantityOffersMedium
    accTotalOffers += d.totalOffers

    accumulatedData.push({
      month: d.month,
      microCLP: accMicroCLP,
      microUSD: accMicroUSD,
      smallCLP: accSmallCLP,
      smallUSD: accSmallUSD,
      mediumCLP: accMediumCLP,
      mediumUSD: accMediumUSD,
      totalEMT_CLP: accTotalEMTCLP,
      totalEMT_USD: accTotalEMTUSD,
      microOrders: accMicroOrders,
      smallOrders: accSmallOrders,
      mediumOrders: accMediumOrders,
      totalOrders: accTotalOrders,
      quantityOffersMicro: accQuantityOffersMicro,
      quantityOffersSmall: accQuantityOffersSmall,
      quantityOffersMedium: accQuantityOffersMedium,
      totalOffers: accTotalOffers
    })
  }

  return accumulatedData
}

export const onGetSmallerCompaniesBySectorThunk =
  ({ year, sector }) =>
  async dispatch => {
    dispatch(onGetSmallerCompaniesBySector())

    try {
      const response = await getSmallerCompaniesSectors({ year, sector })
      const data = response.data.payload.sort((a, b) => a.idMes - b.idMes)

      const enhancedData = data.map(item => {
        const sectorColor = SECTORS_COLORS.find(sector => sector.value === parseInt(item.idSector))?.name

        return {
          year: item.anio,
          month: MONTHS_DICTIONARY.find(d => d.value === parseInt(item.idMes))?.name,
          monthValue: parseInt(item.idMes),
          sector: sectorColor,
          sectorValue: parseInt(item.idSector),
          microCLP: item.montoTransadoMicro,
          microUSD: item.montoTransadoMicroUSD,
          smallCLP: item.montoTransadoPequenia,
          smallUSD: item.montoTransadoPequeniaUSD,
          mediumCLP: item.montoTransadoMediana,
          mediumUSD: item.montoTransadoMedianaUSD,
          totalEMT_CLP: item.montoTransadoTotal,
          totalEMT_USD: item.montoTransadoTotalUSD,
          microOrders: item.cantidadMicroOC,
          smallOrders: item.cantidadPequeniaOC,
          mediumOrders: item.cantidadMedianaOC,
          totalOrders: item.cantidadTotalOC,
          quantityOffersMicro: item.cantidadOfertasMicro,
          quantityOffersSmall: item.cantidadOfertasPequenia,
          quantityOffersMedium: item.cantidadOfertasMediana,
          totalOffers: item.cantidadOfertasTotal
        }
      })

      const accumulatedData = getAccumulatedMonthlyData(enhancedData)
      const microSeries = {
        name: EMT_COLORS.find(d => d.value === 1).name,
        amount: enhancedData.map(d => d.microCLP),
        amountUSD: enhancedData.map(d => d.microUSD),
        amountAccumulated: accumulatedData.map(d => d.microCLP),
        amountAccumulatedUSD: accumulatedData.map(d => d.microUSD),
        orders: enhancedData.map(d => d.microOrders),
        ordersAccumulated: accumulatedData.map(d => d.microOrders),
        quantity: enhancedData.map(d => d.quantityOffersMicro),
        quantityAccumulated: accumulatedData.map(d => d.quantityOffersMicro),
        color: EMT_COLORS.find(d => d.value === 1).color
      }

      const smallSeries = {
        name: EMT_COLORS.find(d => d.value === 2).name,
        amount: enhancedData.map(d => d.smallCLP),
        amountUSD: enhancedData.map(d => d.smallUSD),
        amountAccumulated: accumulatedData.map(d => d.smallCLP),
        amountAccumulatedUSD: accumulatedData.map(d => d.smallUSD),
        orders: enhancedData.map(d => d.smallOrders),
        ordersAccumulated: accumulatedData.map(d => d.smallOrders),
        quantity: enhancedData.map(d => d.quantityOffersSmall),
        quantityAccumulated: accumulatedData.map(d => d.quantityOffersSmall),
        color: EMT_COLORS.find(d => d.value === 2).color
      }

      const mediumSeries = {
        name: EMT_COLORS.find(d => d.value === 3).name,
        amount: enhancedData.map(d => d.mediumCLP),
        amountUSD: enhancedData.map(d => d.mediumUSD),
        amountAccumulated: accumulatedData.map(d => d.mediumCLP),
        amountAccumulatedUSD: accumulatedData.map(d => d.mediumUSD),
        orders: enhancedData.map(d => d.mediumOrders),
        ordersAccumulated: accumulatedData.map(d => d.mediumOrders),
        quantity: enhancedData.map(d => d.quantityOffersMedium),
        quantityAccumulated: accumulatedData.map(d => d.quantityOffersMedium),
        color: EMT_COLORS.find(d => d.value === 3).color
      }

      const series = [microSeries, smallSeries, mediumSeries]
      const csv = [
        [
          'Año',
          'Mes',
          'Sector del estado',
          'Micro Monto (CLP)',
          'Micro Monto(USD)',
          'Pequeña Monto (CLP)',
          'Pequeña Monto(USD)',
          'Mediana Monto (CLP)',
          'Mediana Monto(USD)',
          'Total EMT Monto (CLP)',
          'Total EMT Monto(USD)',
          'Micro Cantidad de órdenes',
          'Pequeña Cantidad de órdenes',
          'Mediana Cantidad de órdenes',
          'Total Cantidad de órdenes',
          'Micro Ofertas a licitaciones',
          'Pequeña Ofertas a licitaciones',
          'Mediana Ofertas a licitaciones',
          'Total Ofertas a licitaciones'
        ],
        ...enhancedData.map(d => [
          d.year,
          d.month,
          d.sector,
          d.microCLP,
          d.microUSD,
          d.smallCLP,
          d.smallUSD,
          d.mediumCLP,
          d.mediumUSD,
          d.totalEMT_CLP,
          d.totalEMT_USD,
          d.microOrders,
          d.smallOrders,
          d.mediumOrders,
          d.totalOrders,
          d.quantityOffersMicro,
          d.quantityOffersSmall,
          d.quantityOffersMedium,
          d.totalOffers
        ])
      ]

      dispatch(
        onGetSmallerCompaniesBySectorSuccess({ csv, data: enhancedData, dataAccumulated: accumulatedData, series })
      )
    } catch (error) {
      dispatch(
        onGetSmallerCompaniesBySectorError({
          error: 'Error al obtener datos',
          csv: [],
          data: [],
          dataAccumulated: [],
          series: []
        })
      )
    }
  }
